export {
  NIAT_PORTAL_PRIVACY_POLICY_URL,
  NIAT_PORTAL_TERMS_AND_CONDITIONS_URL
} from './TermsAndConditionsConstants';

export const NIAT_PORTAL_TERMS_OF_USE_URL =
  'https://www.niatindia.com/terms-of-use';

const linkStyle =
  "cursor: pointer;' referrerpolicy='no-referrer-when-downgrade";

export const seatReservationTermsAndConditionsLabel = `I agree to the&nbsp;<a href='https://www.niatindia.com/terms-and-conditions-2025' target='_blank' class='paymentTerms' style='${linkStyle}'>Program T&amp;C</a>,&nbsp;<a href='https://ccbp.in/privacy-policy' target='_blank' class='paymentTerms' style='${linkStyle}'>Privacy Policy</a>&nbsp;and&nbsp;<a href='${NIAT_PORTAL_TERMS_OF_USE_URL}' target='_blank' class='paymentTerms' style='${linkStyle}'>Terms of Use</a>.`;

export const seatReservationCommunicationConsentLabel =
  'I consent to receive all further updates and communications via WhatsApp, email, or other modes of communication.';

export const seatReservationRefundPolicyLabel =
  'I acknowledge and agree that all payments are non-refundable and non-transferable under any circumstances.';

export const enrollmentGatewayTermsAndConditionsLabel = `I agree to the&nbsp;<a href='https://www.niatindia.com/terms-and-conditions-2025' target='_blank' class='paymentTerms' style='${linkStyle}'>NIAT Program T&amp;C's</a>,&nbsp;<a href='https://ccbp.in/privacy-policy' target='_blank' class='paymentTerms' style='${linkStyle}'>Privacy Policy</a>&nbsp;and&nbsp;<a href='${NIAT_PORTAL_TERMS_OF_USE_URL}' target='_blank' class='paymentTerms' style='${linkStyle}'>Terms of Use</a>&nbsp;of NxtWave Disruptive Technologies Pvt. Ltd. (&quot;NxtWave&quot;).`;

export const enrollmentGatewayCampusChangePolicyLabel =
  "I understand that NxtWave can't facilitate the change of preferred campus and course after enrollment confirmation from the university.";

export const enrollmentGatewayFinalityPolicyLabel =
  'I understand that campus and course selection are final upon enrollment confirmation and cannot be changed thereafter.';

export const enrollmentEscrowTermsAndConditionsLabel =
  enrollmentGatewayTermsAndConditionsLabel;

export const bootcampFeeTermsAndConditionsLabel = `I agree to the&nbsp;<a href='https://www.niatindia.com/terms-and-conditions-2025' target='_blank' class='paymentTerms' style='${linkStyle}'>NIAT Program T&amp;C's</a>,&nbsp;<a href='https://ccbp.in/privacy-policy' target='_blank' class='paymentTerms' style='${linkStyle}'>Privacy Policy</a>&nbsp;and&nbsp;<a href='${NIAT_PORTAL_TERMS_OF_USE_URL}' target='_blank' class='paymentTerms' style='${linkStyle}'>Terms of Use</a>&nbsp;of NxtWave Disruptive Technologies Pvt. Ltd. (&quot;NxtWave&quot;).`;

export const bootcampFeeRefundPolicyLabel =
  'I acknowledge and agree that upskilling payments for NIAT are non-refundable and non-transferable under any circumstances.';

export const bootcampCodeOfConductLabel =
  'I agree to abide by the NIAT Code of Conduct for students.';

export const bootcampTransportAccommodationLabel =
  'I would like to opt for transportation and accommodation.';
